module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card gl-item"
  }, [(_vm.imageUrl) ? _c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "href": _vm.product.url
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imageUrl,
      "alt": ""
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "product-title"
  }, [_c('a', {
    staticClass: "title is-5",
    attrs: {
      "href": _vm.product.url
    }
  }, [_vm._v(_vm._s(_vm.product.name))])]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(_vm.product.short_description))]), _vm._v(" "), (_vm.minPrice) ? _c('p', [_vm._v("от "), _c('b', [_vm._v(_vm._s(_vm.numeral(_vm.minPrice).format('0.00 $')))])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('small', [_vm._v("артикул: " + _vm._s(_vm.product.code))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f6cc322"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/product-list/Item.vue
// module id = 631
// module chunks = 2